import { render, staticRenderFns } from "./RoundedBanner.vue?vue&type=template&id=3327bc62"
import script from "./RoundedBanner.vue?vue&type=script&lang=js"
export * from "./RoundedBanner.vue?vue&type=script&lang=js"
import style0 from "./RoundedBanner.vue?vue&type=style&index=0&id=3327bc62&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports